/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import {CreatedWarehouseLogin} from 'constants/WarehouseConstants';
import WarningBanner from 'ui-library/banners/WarningBanner';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import FormInput from 'ui-library/bs/FormInput';
import Label from 'ui-library/bs/Label';
import Row from 'ui-library/bs/Row';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import Modal from 'ui-library/modals/Modal';

interface Props {
  createLoginModal: {
    creating: boolean;
    createdLogin?: CreatedWarehouseLogin;
    label: string;
  };
  onCreate: (...args: Array<any>) => any;
  onLabelChange: (...args: Array<any>) => any;
  onRequestClose: (...args: Array<any>) => any;
}

class CreateWarehouseLoginModal extends React.Component<Props> {
  _handleCreate = (): void => {
    this.props.onCreate(this.props.createLoginModal.label);
  };

  _handleUpdateLabel = (e: any): void => {
    this.props.onLabelChange(e.target.value);
  };

  render(): JSX.Element {
    let button;
    const {createLoginModal} = this.props;
    const {createdLogin} = createLoginModal;
    if (createLoginModal.creating) {
      button = {key: 'create', text: 'Creating...', disabled: true, submit: true};
    } else if (createdLogin) {
      button = {key: 'create', text: 'Done', cancel: true};
    } else {
      button = {key: 'create', text: 'Create', onClick: this._handleCreate, submit: true};
    }
    return (
      <Modal
        title="Create credentials"
        onRequestClose={this.props.onRequestClose}
        closeable={!createLoginModal.creating}
        buttons={[button]}
      >
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label>Label (optional)</Label>
              <FormInput
                placeholder=""
                value={this.props.createLoginModal.label}
                onChange={this._handleUpdateLabel}
                readOnly={this.props.createLoginModal.creating || createdLogin != null}
              />
            </FormGroup>
          </Col>
        </Row>
        {createdLogin && (
          <>
            <Row>
              <Col md={12}>
                <div>
                  <BenchlingIcon icon="done" className="u-success-color" /> Credentials created!
                </div>
                <div className="u-spacing">
                  <WarningBanner>
                    <>
                      <strong>
                        Make sure you store the password safely <em>now</em>, as it cannot be retrieved later.
                      </strong>
                      <br />
                      For connection instructions and <em>important</em> security considerations,{' '}
                      <a
                        href="https://docs.benchling.com/docs/getting-started"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        please see our guide
                      </a>{' '}
                      (opens in new tab).
                    </>
                  </WarningBanner>
                </div>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label>JDBC &amp; PostgreSQL Connection String</Label>
                  <FormInput
                    readOnly={true}
                    selectAllOnClick={true}
                    value={`postgresql://${createdLogin.username}@${createdLogin.pgConnectParams.host}:${createdLogin.pgConnectParams.port}/${createdLogin.pgConnectParams.dbname}?sslmode=${createdLogin.pgConnectParams.sslmode}`}
                  />
                  <div className="u-tiny-spacing-top">
                    The CA Certificate can be downloaded{' '}
                    <a
                      href="https://truststore.pki.rds.amazonaws.com/global/global-bundle.pem"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      here
                    </a>
                    . Be sure to wrap the connection string in single-quotes for <code>psql</code> and other
                    shell commands!
                  </div>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Username</Label>
                  <FormInput readOnly={true} selectAllOnClick={true} value={createdLogin.username} />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Password</Label>
                  <FormInput readOnly={true} selectAllOnClick={true} value={createdLogin.password} />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Hostname &amp; Port</Label>
                  <FormInput
                    readOnly={true}
                    selectAllOnClick={true}
                    value={`${createdLogin.pgConnectParams.host}:${createdLogin.pgConnectParams.port}`}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Database Name</Label>
                  <FormInput
                    readOnly={true}
                    selectAllOnClick={true}
                    value={createdLogin.pgConnectParams.dbname}
                  />
                </FormGroup>
              </Col>
            </Row>
          </>
        )}
      </Modal>
    );
  }
}

export default CreateWarehouseLoginModal;
